import type { AssociationsAPI, DriverToTokenAssociationAPI, IdentificationTokenAPI, TokenValidationAPI } from './APITypes';
import type { Associations, DriverToTokenAssociation, IdentificationToken, TokenValidation } from './Types';
import moment from 'moment';

import type { TimestampInMillis } from '@cobliteam/common-types';

import type { Driver, DriverGraphQLAPI } from '../driver';

const millisToDateString = (millis?: TimestampInMillis): string | undefined => {
  return (millis && moment(millis).format('YYYY-MM-DD')) || undefined;
};

export const identificationTokenGraphQLToIdentificationToken = (graphQLIdentificationToken: IdentificationTokenAPI): IdentificationToken => {
  return {
    tokenId: graphQLIdentificationToken.token_id,
    tokenType: graphQLIdentificationToken.token_type,
    status: graphQLIdentificationToken.status,
    cobliInternalId: graphQLIdentificationToken.cobli_internal_id,
    fleetId: graphQLIdentificationToken.fleet_id,
    driverId: graphQLIdentificationToken.driver_id,
    associatedToFleetAt: graphQLIdentificationToken.associated_to_fleet_at,
  };
};

export const driverToTokenAssociationtransformer = (driverToTokenAssociation: DriverToTokenAssociationAPI): DriverToTokenAssociation => ({
  driverId: driverToTokenAssociation.driver_id,
  cobliInternalId: driverToTokenAssociation.cobli_internal_id?.toUpperCase(),
});

export const associationsTransformer = (associations: AssociationsAPI): Associations => ({
  associations: associations.associations.map(driverToTokenAssociationtransformer),
});

export const driverToDriverGraphQLAPI = (driver: Driver): DriverGraphQLAPI => {
  const { fleetId, id, name, assigned, phoneNumbers, firstLicenseAcquirementDateInMillis, licenseExpirationDateInMillis, licenseCategory, driverCode } = driver;

  return {
    id,
    name,
    fleet_id: fleetId,
    assigned: assigned === true,
    phone_number: phoneNumbers[0],
    first_license_acquirement_date: millisToDateString(firstLicenseAcquirementDateInMillis),
    license_expiration_date: millisToDateString(licenseExpirationDateInMillis),
    license_category: licenseCategory,
    driver_code: driverCode,
  };
};

export const tokenValidationTransformer = (tokenValidationData: TokenValidationAPI): TokenValidation => ({
  tokenId: tokenValidationData.token_id,
  cobliInternalId: tokenValidationData.cobli_internal_id,
  fleetId: tokenValidationData.fleet_id,
  driver: tokenValidationData.driver,
});
